module.exports = __webpack_public_path__ + "static/error-446eb46517128db9b63c3c2b849b68b2.svg";